import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import TradePage from './TradePage';

const TradePageRoute: React.FC = () => {
    const { symbol, tradeId } = useParams();
    const [searchParams] = useSearchParams();
    const date = searchParams.get('date');

    if (!symbol || !tradeId || !date) {
        return (
            <div className='TradePageError'>
                <h4>Missing parameters</h4>
                <p>URL must include symbol, trade ID and date. Example: /trade/MAREL/12345?date=2026-04-15</p>
            </div>
        );
    }

    return <TradePage symbol={symbol} tradeId={tradeId} date={date} />;
};

export default TradePageRoute;
